import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { Toaster } from "react-hot-toast";
const App = () => {
  return (
    <>
    <Toaster/>
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
     
      <Route path="/" element={<Navigate to="/auth" replace />} />
    </Routes>
    </>
  );
};

export default App;
